var sentryConfiguration = (function () {
    'use strict';

    function init() {
        if (typeof Sentry === "undefined") {
            console.error("Sentry SDK global object not found. Check script loading order.");
            return;
        }

        Sentry.init({
            dsn: "https://8ad47ade3a4148a4895a3b4add81aa32@sentry.ci.uktrade.digital/289",

            // Adds request headers and IP for users, for more info visit:
            // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
            sendDefaultPii: true,

            // Alternatively, use `process.env.npm_package_version` for a dynamic release version
            // if your build tool supports it.
            release: "ukmcab@5.8",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for tracing.
            // We recommend adjusting this value in production
            // Learn more at
            // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
            tracesSampleRate: 0.0,

            // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/sentry\.ci\uktrade\.digital/],

            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            // Learn more at
            // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });

        console.log("Sentry successfully initialized via external module.");
    }

    return {
        init: init
    };
})();

sentryConfiguration.init();

